<template>
    <gofix-form-dropdown
        :vLabel="vLabel"
        :label="label" 
        :filterable="filterable" 
        :required="required"
        :show-icon-required="showIconRequired"
        :append-to-body="appendToBody"
        :disabled="disabled"
        :reduce="reduce"
        :options="options"
        @search="searchOptions"
        :value="value"
        @input="handleInput" >
    </gofix-form-dropdown>
</template>

<script>
    export default {
        name: "dropdown-projects",
        props: {
            value: {
                required: true,
                default: () => null
            },
            projectId: {
                type: Number,
                required: false,
                default: null
            },
            vLabel: {
                type: String,
                required: false,
                default: () => "name"
            },
            label: {
                type: String,
                required: false,
                default: () => "Subcontractor"
            },
            filterable: {
                type: Boolean,
                required: false,
                default: () => false
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            appendToBody: {
                type: Boolean,
                required: false,
                default: () => true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            reduce: {
                type: Function,
                default: option => option,
            },
        },

        data() {
            return {
                options: [],
                timer: null
            }
        },
        watch: {
            projectId: function() {
                this.getOptions()
            }
        },
        created(){
            this.getOptions()
        },
        methods: {
            async getOptions(search = '') {
                if(!this.projectId) {
                    this.options = []
                    return
                }
                let tableRequest = {
                    filter: { 
                        project_id: this.projectId, 
                        name: search 
                    },
                    page: 1,
                    limit: 100
                }

                await this.$store.dispatch("SafetyAppController/getCompanies", tableRequest)
                    .then(response => {
                        this.options = response.items;
                    })
                    .catch(err => {})
            },
            async searchOptions(search, loading) {
                loading(true)
                this.options = []
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOptions(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
        }
    }
</script>

<style scoped>

</style>
